import React, {useState, useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {CloseOutlined} from '@ant-design/icons';
import {IncidentActionProps} from '../IncidentActionMenuTypes';
import UpdateIncidentForm from './UpdateIncidentForm';
import {useMounted} from '../../../../../hooks/useMounted';
import {IncidentStatus} from 'hemwb-api';
import {incidentUpdate} from '../../../../../store/incident';
import {messageAdd, MessageTypes} from '../../../../../store/message';
import styles from './UpdateIncident.module.scss';

const UpdateIncident: React.FC<IncidentActionProps> = ({
  status,
  incidentId,
  onSuccess,
  onCancel,
  reportId,
  issueSummary,
}) => {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);
  const mounted = useMounted();

  const handleSubmit = useCallback(
    (status: IncidentStatus, comments: string) => {
      setSubmitting(true);
      return incidentUpdate(dispatch, incidentId ?? '', {
        issueSummary: issueSummary || '',
        reportId: reportId || 0,
        status: status,
        comments: comments || '',
      })
        .then(() => {
          dispatch(messageAdd(`The incident has been updated`, MessageTypes.SUCCESS));
          onSuccess?.(status, comments);
        })
        .catch(() => null)
        .finally(() => {
          mounted.current && setSubmitting(false);
        });
    },
    [dispatch, onSuccess, mounted, incidentId, issueSummary, reportId],
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <h2 className={styles.title}>Edit Status</h2>
        </div>
        <button className={styles.closeBtn} onClick={onCancel} aria-label="Close">
          <CloseOutlined />
        </button>
      </div>
      <div className={styles.formWrapper}>
        <p className={styles.description}>
          Update the Incident&apos;s status and include any closing comments for the user
        </p>
        <UpdateIncidentForm submitting={submitting} status={status} onCancel={onCancel} onSubmit={handleSubmit} />
      </div>
    </div>
  );
};

export default UpdateIncident;
